"use client";
import Avvvatars from "avvvatars-react";
import { useState } from "react";

const CustomImage = ({
  src,
  alt="",
  size = 40,
  border = true
}: {
  src: string;
  alt: string;
  size: number;
  border?: boolean;
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const handleError = () => {
    setImgSrc("/path/to/default/image.jpg");
  };
  if (!imgSrc || imgSrc?.length == 0) {
    const [first, last] = alt?.split(" ");
    return (
      <Avvvatars
        value={alt}
        size={size}
        displayValue={first + last}
        style="character"
        border={border}
      />
    );
  }
  return (
    <div
      className="rounded-full overflow-hidden border border-gray-200"
      style={{ height: size, width: size }}
    >
      <img
        className="text-white object-contain rounded-full"
        src={imgSrc || "/user.png"}
        height={size}
        width={size}
        alt={alt}
        onError={handleError}
      />
    </div>
  );
};
export default CustomImage;
